import { AxiosError } from 'axios';
import { eventsRequest } from '../../utils/eventsRequest';
import { SESSION_KEY_JWT } from '../../constants';
import { ErrorResponse } from '../../types';

interface CartResponseData {
    data: {
        coupons: { id: string }[];
    };
}

const removeCoupon = async () => {
    let arrayResponse = {
        success: false,
        message: 'Failed to remove coupon.',
    };

    try {
        const jwtToken = localStorage.getItem(SESSION_KEY_JWT);
        if (!jwtToken) {
            return arrayResponse;
        }

        const cartResponse = await eventsRequest<CartResponseData>(`/cart`, 'get');

        if (cartResponse.status !== 200) {
            return arrayResponse;
        }

        const couponId = cartResponse.data.data.coupons[0]?.id;

        if (!couponId) {
            return arrayResponse;
        }

        // Delete the coupon using the retrieved couponId
        const response = await eventsRequest(`/cart/coupon/${couponId}`, 'delete');

        if (response.status === 200 || response.status === 201) {
            arrayResponse.success = true;
            arrayResponse.message = 'Coupon removed.';
        }
        return arrayResponse;
    } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response && axiosError.response.status === 400) {
            arrayResponse.message = axiosError.response.data.message;
        }
        return arrayResponse;
    }
};

export default removeCoupon;
